import TodoServices from 'services/todo/TodoServices';

const archiveTodoUseCase =
  (todoServices: TodoServices) => async (todoID: string) => {
    await todoServices.archive(todoID);
  };

export default archiveTodoUseCase;
